module.exports = __webpack_public_path__ + "img/zhuangshi.158c87ac.png";